<script>
    import { selectedItem } from '../../../store/store.js';
    import { displayInt } from '../../../utils/utils.js';
</script>

{#if $selectedItem.suggestions_and_improvements.length > 0}
<div class="key-value-table box">
    <h5>Förslag på förbättringar</h5>
    <table>
        <colgroup>
            <col style="width: 65%;">
            <col style="width: 30%;">
            <col style="width: 5%;">
        </colgroup>
        <tbody>
            {#each $selectedItem.suggestions_and_improvements as improvement}
            <h5>Förbättringsbeskrivning</h5>
            <h6>{ improvement.improvement_description }</h6>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Energibesparing</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt(improvement.energy_saving_per_year) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>CO₂-minskning</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt(improvement.co2_reduction) } ton/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Kostnad per energi</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt(improvement.cost_per_saved_energy) } kr/kWh</h6>
                </td>
                <td class="column3">
                </td>
            </tr><tr class="row100 body">
                <td class="column1">
                    <h6>Kostnad</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt(improvement.total_cost) } kr</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            {/each}
        </tbody>
    </table>
</div>
{/if}